import { render, staticRenderFns } from "./DriverSummaryTable.vue?vue&type=template&id=2b196de2&scoped=true&"
import script from "./DriverSummaryTable.vue?vue&type=script&lang=js&"
export * from "./DriverSummaryTable.vue?vue&type=script&lang=js&"
import style0 from "./DriverSummaryTable.vue?vue&type=style&index=0&id=2b196de2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b196de2",
  null
  
)

export default component.exports